import { AuthenticationClient } from '../authentication/client';

import { Filter, FilterAccess } from './types';

/**
 * Checks if filter is shared with current user.
 * @param filter the filter to check
 * @returns true, if the filter is shared with the current user, false otherwise
 */
export const isFilterShared = (filter: Filter): boolean => {
  const userId = AuthenticationClient.getInstance().getUser()?.userId;
  return filter.permissions.some(x => x.access === FilterAccess.View && x.user.id === userId);
};
